import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Divider,
  Button,
  useTheme,
} from '@mui/material';
import PageHeader from '../../components/common/PageHeader';

const Analytics: React.FC = () => {
  const theme = useTheme();

  return (
    <Box>
      <PageHeader
        title="Analytics"
        subtitle="View and analyze account performance metrics"
      />

      <Box sx={{ mb: 4 }}>
        <Card>
          <CardContent sx={{ textAlign: 'center', py: 8 }}>
            <Typography variant="h5" gutterBottom>
              Analytics Dashboard Coming Soon
            </Typography>
            <Typography variant="body1" color="text.secondary" paragraph>
              This feature is currently under development and will be available in a future update.
            </Typography>
            <Typography variant="body2" color="text.secondary" paragraph>
              The analytics dashboard will provide detailed insights into account performance,
              payment trends, and credit utilization metrics to help you make informed decisions.
            </Typography>
            <Button
              variant="contained"
              color="primary"
              disabled
            >
              Explore Analytics
            </Button>
          </CardContent>
        </Card>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h5" gutterBottom>
          Planned Features
        </Typography>
        <Divider sx={{ mb: 2 }} />

        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 2 }}>
          <Card sx={{ flex: 1 }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Account Performance
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Track account payment history, credit utilization, and overall financial health with
                interactive charts and visualizations.
              </Typography>
            </CardContent>
          </Card>

          <Card sx={{ flex: 1 }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Payment Trends
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Analyze payment patterns, identify late payment trends, and forecast future payment
                behavior based on historical data.
              </Typography>
            </CardContent>
          </Card>

          <Card sx={{ flex: 1 }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Custom Reports
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Generate customized reports with the metrics that matter most to your business,
                with options to export in various formats.
              </Typography>
            </CardContent>
          </Card>
        </Box>
      </Box>

      <Box>
        <Typography variant="h5" gutterBottom>
          Development Timeline
        </Typography>
        <Divider sx={{ mb: 2 }} />

        <Card>
          <CardContent>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Box>
                <Typography variant="h6" gutterBottom>
                  Phase 1: Basic Analytics (Q3 2025)
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Implementation of core analytics features including account performance metrics
                  and basic reporting capabilities.
                </Typography>
              </Box>

              <Box>
                <Typography variant="h6" gutterBottom>
                  Phase 2: Advanced Insights (Q4 2025)
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Addition of predictive analytics, trend forecasting, and enhanced visualization
                  tools for deeper insights.
                </Typography>
              </Box>

              <Box>
                <Typography variant="h6" gutterBottom>
                  Phase 3: Custom Reporting (Q1 2026)
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Development of fully customizable reporting system with export options and
                  scheduled report delivery.
                </Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};

export default Analytics;
